import { postRequest } from 'utils/http'

export const sendEmail = payload => {
  return postRequest(`/users/forgot-password-email`, payload)
}
